// Tiny tween system ticked from the render loop. No dependencies.

type Tween = {
  start: number;
  dur: number;
  delay: number;
  onUpdate: (t: number) => void;
  onComplete?: () => void;
  started: boolean;
};

const tweens: Tween[] = [];

export function tween(
  durMs: number,
  onUpdate: (t: number) => void,
  opts: { delay?: number; onComplete?: () => void; ease?: (t: number) => number } = {},
): void {
  const ease = opts.ease ?? easeOutCubic;
  tweens.push({
    start: performance.now(),
    dur: Math.max(1, durMs),
    delay: opts.delay ?? 0,
    onUpdate: (t) => onUpdate(ease(t)),
    onComplete: opts.onComplete,
    started: false,
  });
}

export function updateTweens(now: number): void {
  for (let i = tweens.length - 1; i >= 0; i--) {
    const tw = tweens[i];
    const elapsed = now - tw.start - tw.delay;
    if (elapsed < 0) continue;
    let t = elapsed / tw.dur;
    if (t >= 1) t = 1;
    tw.onUpdate(t);
    if (t >= 1) {
      tweens.splice(i, 1);
      tw.onComplete?.();
    }
  }
}

export const easeOutCubic = (t: number): number => 1 - Math.pow(1 - t, 3);
export const easeInCubic = (t: number): number => t * t * t;
export const easeOutBack = (t: number): number => {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
};
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
/** Smoothstep ease-in-out — matches the Unity tray/lid animation tangents. */
export const smoothstep = (t: number): number => t * t * (3 - 2 * t);
